// extracted by mini-css-extract-plugin
module.exports = {"downloadApp":"DownloadApp_downloadApp__Nwtrl","macOS":"DownloadApp_macOS__gqxAq"};